import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import Download from '../../../../assets/svg/Feather/Download';

export default (dispatch) => ({
  exportAllFeatures: (type) => () => {
    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Exporting your content...',
        loader: true
      }
    });

    dispatch({
      type: 'dataManager/setIsExporting',
      payload: true
    });

    dispatch({
      type: 'features/exportFeatures',
      payload: {
        fileType: type,
        featureIds: null
      },
      callback: (exportId) => {
        if (!exportId) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an error generating your export.',
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });
        } else {
          dispatch({
            type: 'features/getExportPoll-start',
            payload: exportId,
            callback: (exportUrl) => {
              dispatch({
                type: 'features/getExportPoll-stop',
              });

              setTimeout(() => {
                if (exportUrl) {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Preparing to download...',
                      loader: true
                    }
                  });

                  window.open(exportUrl, '_blank');
                  
                  dispatch({
                    type: 'dataManager/setIsExporting',
                    payload: false
                  });

                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Click here if download has not started.',
                      icon: Download,
                      dismissable: true,
                      onClick: (e) => {
                        window.open(exportUrl, '_blank');

                        dispatch({
                          type: 'toast/dismiss'
                        });
                      }
                    }
                  });
                } else {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'There was an error fetching your export.',
                      icon: AlertCircle,
                      iconColor: '#FF3B30',
                      dismissable: true
                    }
                  });
                }
              }, 3500);

              dispatch({
                type: 'features/resetAllSelectedFeatures',
              });
            }
          });
        }
      }
    });
  },
});